import {Component, Input, OnChanges} from "@angular/core";
import { ITCIMarketplaceListing, TCI_MARKETPLACE_LISTING_VIEW_MODE } from "@tci/common";
import { cloneDeep } from "lodash";

@Component({
    selector: "ng-marketplace-v2-preview",
    templateUrl: "./ng-marketplace-v2-preview.component.html",
    styleUrls: ["./ng-marketplace-v2-preview.component.less"]
})
export class NgMarketplaceV2PreviewComponent implements OnChanges {
    @Input() input: ITCIMarketplaceListing;
    previewAsset: ITCIMarketplaceListing;

    cardMode = TCI_MARKETPLACE_LISTING_VIEW_MODE.PREVIEW_CARD;
    detailMode = TCI_MARKETPLACE_LISTING_VIEW_MODE.PREVIEW_DETAIL;

    ngOnChanges() {
        this.previewAsset = cloneDeep(this.input);
        delete this.previewAsset.lastCertifiedDate;
    }
}
